import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import numberValidation from 'utils/validations/numberValidation';
import pismenaCislaValidation from 'utils/validations/pismenaCislaValidation';
import { rcmaValidationSimple } from 'utils/validations/rcmaValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF8 {}

const F8: React.FC<IF8> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();

    const [nepovinneValErr, setNepovinneValErr] = useState<boolean>(false);
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (fieldsValue.rliv || fieldsValue.rli2 || fieldsValue.idve || fieldsValue.idbl || fieldsValue.rcma) {
            const dataToSend = {
                ...fieldsValue,
                dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
            };
            onFormSubmit(dataToSend);
        } else {
            setNepovinneValErr(true);
        }
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F8" />
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f8ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <LoadingWrapper loading={dateLoading}>
                                <DatePickerComponent
                                    name="dtvp"
                                    label="DUVERNE_INFO_POZADOVANY_DEN"
                                    disabled={currentStep > 0}
                                    disabledDate={current => commonDisabledDate(current)}
                                />
                            </LoadingWrapper>
                            <InputComponent
                                label="ME_POZADAVKY_ID1"
                                name="rliv"
                                type="text"
                                maxLength={12}
                                disabled={currentStep > 0}
                                rules={numberValidation()}
                                notRequired={true}
                                hide={currentStep === 1 && !form.getFieldValue('rliv')}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_ID2"
                                name="rli2"
                                type="text"
                                hide={currentStep === 1 && !form.getFieldValue('rli2')}
                                maxLength={12}
                                disabled={currentStep > 0}
                                rules={numberValidation()}
                                notRequired={true}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_VERITEL"
                                name="idve"
                                type="text"
                                maxLength={50}
                                rules={pismenaCislaValidation()}
                                notRequired={true}
                                hide={currentStep === 1 && !form.getFieldValue('idve')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_SUBJPPN"
                                name="idbl"
                                type="text"
                                maxLength={100}
                                notRequired={true}
                                hide={currentStep === 1 && !form.getFieldValue('idbl')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="CISLO_UCTU"
                                name="rcma"
                                type="text"
                                rules={rcmaValidationSimple()}
                                notRequired={true}
                                maxLength={12}
                                hide={currentStep === 1 && !form.getFieldValue('rcma')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            {currentStep !== 0 && upozorneni && (
                                <AlertComponent upozorneni={upozorneni} type={currentStep === 1 ? 'error' : 'info'} />
                            )}
                            <Row className="button-row">
                                {currentStep === 1 && (
                                    <ButtonComponent
                                        id="f8ZpetAltBtn"
                                        buttontext="ZPET"
                                        onClick={() => prev()}
                                        type="default"
                                    />
                                )}
                                <ButtonComponent id="f8OdeslatBtn" buttontext="ODESLAT" onClick={() => form.submit()} />
                            </Row>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F8;
